'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Arrow = function (_React$Component) {
    _inherits(Arrow, _React$Component);

    function Arrow() {
        _classCallCheck(this, Arrow);

        return _possibleConstructorReturn(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).apply(this, arguments));
    }

    _createClass(Arrow, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, {
                    d: 'M25.025 13.224c-3.004 2.586-6.016 5.162-9.026 7.739-3.009-2.577-6.017-5.155-9.025-7.735 0.623-0.731 1.251-1.457 1.871-2.19 2.393 2.031 4.767 4.087 7.155 6.124 2.283-1.955 4.564-3.913 6.847-5.869 0.101-0.087 0.2-0.176 0.307-0.256 0.62 0.732 1.245 1.46 1.871 2.187z' })
            );
        }
    }]);

    return Arrow;
}(_react2.default.Component);

Arrow.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Arrow;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/arrow.js
// module id = 1085
// module chunks = 0